import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExtendedUseFormReturn } from '../../../../../hooks/providers/useFormHooks';
import { FirstNameInput } from './inputs/FirstNameInput';
import { LastNameInput } from './inputs/LastNameInput';
import { EmailNameInput } from './inputs/EmailInput';
import { InviteFormTermsType, InviteTermsCheckbox } from './InviteTermsCheckbox';
import { InviteFormType } from '../InviteFormStep';

interface AdminFormProps {
  formMethods: ExtendedUseFormReturn<InviteFormType>;
  onTermsClick: (type: InviteFormTermsType) => void;
}

export const AdminForm = ({ formMethods, onTermsClick }: AdminFormProps) => {
  const { t } = useTranslation('inviteEN');
  return (
    <form onSubmit={(event) => event.preventDefault()} id='rhfWrapper' className='flex flex-col w-full'>
      <div className='flex flex-col gap-[4px] w-full'>
        <div className='flex flex-row w-full gap-[24px]'>
          <div className='w-full'>
            <FirstNameInput control={formMethods.control} />
          </div>
          <div className='w-full'>
            <LastNameInput control={formMethods.control} />
          </div>
        </div>
        <EmailNameInput control={formMethods.control} title={t('INVITE_FORM.INPUTS.EMAIL.ADMIN')} />
      </div>
      <div className='flex flex-col gap-[16px] mt-[14px]'>
        <InviteTermsCheckbox
          formMethods={formMethods}
          onTermsClick={() => onTermsClick(InviteFormTermsType.ADMIN_CORPORATE_RESOLUTION)}
          type={InviteFormTermsType.ADMIN_CORPORATE_RESOLUTION}
          title={t('INVITE_FORM.CHECKBOX.ADMIN.CORPORATE_RESOLUTION.TITLE')}
          linkText={t('INVITE_FORM.CHECKBOX.ADMIN.CORPORATE_RESOLUTION.LINK')}
        />
        <InviteTermsCheckbox
          formMethods={formMethods}
          onTermsClick={() => onTermsClick(InviteFormTermsType.APPOINT_ADMIN)}
          type={InviteFormTermsType.APPOINT_ADMIN}
          title={t('INVITE_FORM.CHECKBOX.ADMIN.APPOINT_ADMIN.TITLE')}
          linkText={t('INVITE_FORM.CHECKBOX.ADMIN.APPOINT_ADMIN.LINK')}
        />
      </div>
    </form>
  );
};
